import {computed, defineComponent, onMounted, onUnmounted, type PropType, ref, toRefs, watch} from 'vue';
import {useFormatting} from "@/composables/currency-format.ts";
import {type Service, useUserStore} from "@/app/stores/user-store.ts";
import {useRouter} from "vue-router";
import {TopUp} from "@/app/wallet/wallet-routes.ts";
import {AthumiService, type OperationsActorServiceInfo} from "@/api/enterprise-gateway-api.proxy.ts";

export default defineComponent({
    name: 'AegWalletDetails',
    props: {
        serviceWallet: {
            type: Object as PropType<Service>,
            required: true,
            default: undefined
        }   
    },
    setup(props) {
        const {formatCurrency} = useFormatting();
        const router = useRouter();
        const userStore = useUserStore();        
        const loading = ref<boolean>(false);
        const isMobileWidth = ref<boolean>(window.innerWidth <= 768);
        const serviceWallet = ref(<Service> {
            walletAmount: 0,
            walletUnavailable: true,
            service: AthumiService.All
        });
        
        const errorLoading = computed(() => {
            return serviceWallet.value.walletUnavailable;
        })

        const handleResize = () => {
            isMobileWidth.value = window.innerWidth <= 768;
        };

        const reload = async () => {
            try {
                loading.value = true;
                await userStore.updateUserData();
            } finally {
                loading.value = false;
            }
        }
        
        const goToTopUpWallet = async () => {
            await router.push({
                name: TopUp.name,
                params: {service: serviceWallet.value.service}
            });
        }

        const serviceWalletChanged = async (newServiceWallet: Service | undefined) => {
            if (!newServiceWallet) return;
            
            serviceWallet.value.walletAmount = newServiceWallet.walletAmount;
            serviceWallet.value.walletUnavailable = newServiceWallet.walletUnavailable;
            serviceWallet.value.service = newServiceWallet.service;
        }
        
        const title = computed(() => {
            return `${serviceWallet.value.service}-saldo van uw organisatie`;
        });
        
        watch(() => props.serviceWallet, serviceWalletChanged, {immediate: true, deep: true});

        onMounted(() => {
            window.addEventListener('resize', handleResize);
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });
        
        return {
            loading,
            errorLoading,
            serviceWallet,
            isMobileWidth,
            title,
            formatCurrency,
            goToTopUpWallet,
            reload
        }
    }
})
